import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

export interface GetMemberResponse {
    member_idx: number;
    m_category: number;
    m_category_text: string;
    m_name: string;
    m_mobile: string;
    m_email: string;
    m_memo: string;
    m_level: number;
    reg_date: string;
    customer_idx: number;
    customer_name: string;
    order_count: number;
    total_sales_amount: number;
    delivery_completed_count: number;
}
export const useGetMemberInfo = (memberId: number): UseQueryResult<GetMemberResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetMemberResponse, Error>({
        queryKey: ["getMemberInfo", memberId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_member_info}/${memberId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!memberId,
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
